var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-container',{ref:"container"},[_c('ArtisanGrid',{ref:"grid",attrs:{"metaKey":"SysApiInfo","leftOption":_vm.option},on:{"syncApi":_vm.syncApi}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }